import { Badge } from "@/components/kit";
import { cn } from "@/lib/utils";
import type { ImportOrderLineMatchStatus } from "@/server/platform/db/schema/inventory";
import {
  IMPORT_ORDER_LINE_MATCH_CLASS,
  IMPORT_ORDER_LINE_MATCH_LABELS,
} from "../lib/import-order-labels";

type ImportOrderPendingBadgeProps = {
  status: ImportOrderLineMatchStatus;
  className?: string;
};

export function ImportOrderPendingBadge({
  status,
  className,
}: ImportOrderPendingBadgeProps) {
  if (status === "matched") return null;

  return (
    <Badge className={cn(IMPORT_ORDER_LINE_MATCH_CLASS[status], className)}>
      {IMPORT_ORDER_LINE_MATCH_LABELS[status]}
    </Badge>
  );
}

export function ImportOrderPendingCountBadge({
  count,
}: {
  count: number;
}) {
  if (count <= 0) return null;

  return (
    <Badge className={IMPORT_ORDER_LINE_MATCH_CLASS.pending}>
      {count} ລໍຖ້າຈັບຄູ່
    </Badge>
  );
}
